import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-risk-prioritization-report-dw",
  templateUrl: "./risk-prioritization-report-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskPrioritizationReportDwComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.RISK_PRIORITIZATION_REPORT_DW;
  hideFilters = [HideFilters.PROJECT_ID, HideFilters.ORG_ID, HideFilters.USER_ID, HideFilters.PROJECT_NAME];
}
